import React from "react";
import {
  Box,
  LabelStyled,
  SpanStyled,
} from "../../../../components/styled/Elements";

/**
 * Mobile-style property type + advertising license row for listing cards.
 */
export const listingPropertyTypeLabel = (item, language) => {
  const type = item?.listing_property_type;
  if (Number(type?.id) === 7) {
    return language === "en"
      ? type?.other_prop_type_en || type?.name || "—"
      : type?.other_prop_type_ar || type?.name || "—";
  }
  return type?.name || "—";
};

const ListingCardMeta = ({ item, language, t }) => {
  return (
    <Box className="d-flex gap-3 px-2 px-lg-0 mb-3 pt-2 border-top">
      <Box className="flex-fill min-w-0">
        <LabelStyled className="mb-1" size="14px" color="#474F63">
          {t("property_type")}
        </LabelStyled>
        <SpanStyled size="14px" color="var(--lightGrey)" className="d-block text-truncate">
          {listingPropertyTypeLabel(item, language)}
        </SpanStyled>
      </Box>
      <Box className="flex-fill min-w-0">
        <LabelStyled className="mb-1" size="14px" color="#474F63">
          {t("advertising_license")}
        </LabelStyled>
        <SpanStyled size="14px" color="var(--lightGrey)" className="d-block text-truncate">
          {item?.ad_number || "—"}
        </SpanStyled>
      </Box>
    </Box>
  );
};

export default ListingCardMeta;
